import { useContext } from 'react';
import { ThemeContext } from '../ThemeContext';
import type { CustomThemeConfig } from '../types';

export const useGetTheme = (): CustomThemeConfig => {
  const theme = useContext(ThemeContext);

  if (theme === undefined) {
    throw new Error('useGetTheme must be used within a ThemeProvider');
  }

  return theme;
};
